// Counts feature use that already goes through Redux: paywalls, modals,
// display settings and search. Everything else calls track() where it
// happens.

import { modalActionTypes } from '../api/modals/actions';
import { profileActionTypes } from '../api/profile/actions';
import { searchActionTypes } from '../api/search/actions';
import { track, trackOnce } from '.';

// Profile keys a person changes on purpose, and their name in the report.
const DISPLAY_SETTINGS = {
    chordColor: 'chord_color',
    fontSize: 'font_size',
    lineHeight: 'line_height',
    showChords: 'show_chords',
    showChordCradle: 'chord_cradle',
    songLayout: 'layout',
    darkMode: 'dark_mode',
    instrument_preference: 'instrument',
    language_preference: 'song_languages',
    screenWakeLock: 'keep_awake',
};

const PDF_WIZARD = /^modal-(song|songbook)-pdf-/;

function modalOpened({ name, message }) {
    if (name === 'modal-paywall') {
        track('paywall_shown', message ? { source: message } : undefined);
    } else if (name === 'modal-subscription') {
        track('subscription_modal_opened');
    } else if (name === 'modal-qr') {
        track('qr_share_opened');
    } else if (name.startsWith('modal-chordchooser-')) {
        track('chord_chooser_opened');
    } else if (PDF_WIZARD.test(name)) {
        track('pdf_wizard_opened', { kind: name.match(PDF_WIZARD)[1] });
    }
}

export default function usageMiddleware({ getState }) {
    return next => action => {
        try {
            if (action.type === modalActionTypes.OPEN && typeof action.name === 'string') {
                modalOpened(action);
            } else if (action.type === profileActionTypes.SET_KEY && DISPLAY_SETTINGS[action.key]) {
                // Sliders also report the old value back, e.g. when a paywall stops the change.
                const current = (getState().profile.ui_preferences || {})[action.key];
                if (String(current) !== String(action.value)) {
                    const setting = DISPLAY_SETTINGS[action.key];
                    trackOnce('display_setting_changed', { setting }, setting);
                }
            } else if (action.type === searchActionTypes.RECEIVE) {
                trackOnce('searched');
            }
        } catch (e) {
            // Counting must never get in the way of the action itself.
        }
        return next(action);
    };
}
